import React, { useCallback } from 'react';
import styled from 'styled-components';
import { globalTheme } from '@clds/component-theme';
import { RadioGroup } from '@clds/radio';
import Tooltip from '@clds/tooltip';
import { InlineFieldLayout, Label } from '@clds/form';
import t from 'common/i18n';
import { useFilterParams } from '../../../common/selectors';
import { LICENSE_MODEL_OPTIONS } from '../../../common/data/consts';
import { SectionBox } from '../../../common/components/FiltersPanel/Filters.styles';

const InlineFieldLayoutCustomized = styled(InlineFieldLayout)`
  padding-bottom: ${globalTheme.spacing.xs};
`;
const RadioLabel = styled(Label)`
  padding-top: 1px; // aligment fix
`;

export default ({ handleSearch, source }) => {
  const { licenseModels, licenseType } = useFilterParams(source);
  const isLicenseCreative = licenseType === 'creative';
  const options = LICENSE_MODEL_OPTIONS.map((value) => ({ label: t(`${source}.filters.license_model.${value}`), value }));

  const filterChange = useCallback(
    (item) => {
      handleSearch({
        filters: {
          licenseModels: item,
        },
      });
    },
    [handleSearch]
  );

  return (
    <Tooltip trigger="hover" title={!isLicenseCreative ? t(`${source}.filters.available_for_creative_videos`) : null} placement="top">
      <div>
        <SectionBox data-test="license-model-section" disabled={!isLicenseCreative}>
          <label>{t(`${source}.filters.license_model.label`)}</label>
          <RadioGroup name="license-model-radio-group" value={licenseModels} onChange={filterChange}>
            {options.map((item) => (
              <InlineFieldLayoutCustomized
                key={item.value}
                label={
                  <RadioLabel htmlFor={`license_model_${item.value}`} data-test={item.value}>
                    {item.label}
                  </RadioLabel>
                }
              >
                <RadioGroup.Radio id={`license_model_${item.value}`} value={item.value} />
              </InlineFieldLayoutCustomized>
            ))}
          </RadioGroup>
        </SectionBox>
      </div>
    </Tooltip>
  );
};
